/* Core & libraries */
import React, { useEffect, useState } from "react";

/* Helpers, constants, custom methods, internal libraries */
import { useAirlineProgramsService } from "../../services/airlineProgramsService.js";
import { PAGE_TITLES } from "../../constants/appConstants";
import { useAnalytics } from "../../hooks/useAnalytics";

/* Components */
import AAProgramHeader from "../../components/aaProgramHeader";
import AAProgramContent from "../../components/aaProgramContent";
/* Styles */

const ProgramAA = () => {
    const { getAirlineProgramsData, delinkAmericanAirlines, airlineProgramsData, joinAmericanAirlines } = useAirlineProgramsService();
    const { initAnalytics } = useAnalytics();
    const [americanAirlinesSupplier, setAmericanAirlinesSupplier] = useState({});

    useEffect(() => {
        (async () => {
            await getAirlineProgramsData()
        })();
        const initUtagData = {
            channel: 'content',
            pageName: PAGE_TITLES["americanAirlines"]
        };
        initAnalytics(initUtagData, 'init call', 'view')
    }, []);
    
    useEffect(() => {
        setAmericanAirlinesSupplier(airlineProgramsData?.suppliers?.filter(
            supplier => supplier.providerName === "American Airlines"
        )[0])
    }, [airlineProgramsData]);

    return (
        <div className="program-page">
            <AAProgramHeader airlineProgramsData={airlineProgramsData}/>
            <AAProgramContent
                delinkAmericanAirlines={delinkAmericanAirlines} 
                americanAirlinesSupplier={americanAirlinesSupplier} 
                joinAmericanAirlines={joinAmericanAirlines}
            />
        </div>
    )
}

export default ProgramAA;
